// Imports
  // React
	import React, { useContext } from 'react'
  // Context
	import {CartContext} from '../context/CartContext'

	
	

// rafce

const CartWidgetCounter = ( ) => {

  const {items, getTotal} = useContext(CartContext);

    return (
    <>
      <span className={ items.length === 0 ? 'cartWidget-counter' : 'cartWidget-counter cartWidget-counter-active' }>{getTotal()}</span>
    </>
  )
}

export default CartWidgetCounter